module.exports = __webpack_public_path__ + "static/media/vacciplant.f94433bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/climasense/tizon_fuego_manzano/preventiva/vacciplant.png
// module id = 1751
// module chunks = 3